module.exports = __webpack_public_path__ + "assets/images/p6_f40d3682960120d82a4b0c419d3667cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packs/p6.png
// module id = 130
// module chunks = 0